module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrBold.47f1fb1.woff";